module.exports = __webpack_public_path__ + "img/banner-awards.b4f03189.jpg";